import styled from 'styled-components';

export const ContentInfoClient = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  width: 100%;
  margin-top: 15px;

  > span {
    font-weight: 500;
    margin-bottom: 15px;
  }

  form {
    width: 100%;
    div {
      > div {
        > div {
          border: 1px solid var(--primary);
        }
      }
    }
  }
`;

export const ColButton = styled.div`
  widht: 100%;
  max-width: 300px;
  min-width: 70px;
  margin: 30px auto 15px auto;
`;

export const ColInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  margin: 0 auto;
  margin-top: 8px;
  width: 100%;
  max-width: 400px;
  min-widht: 200px;
`;

export const InfoClient = styled.div`
width: 100%;
margin-bottom: 15px;
span {
  font-weight: 500;
}
p {
  margin-top: 15px;
}
> div {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  div {
    display: flex;
    flex: 1;
    margin-left: 5px;
    justify-content: space-between;

    button {
      display: flex;
      align-items: center;
      cursor:pointer;
      svg {
        margin-right: 5px;
      }
     }
  }
}
`